import imag1st from "../../asset/imageHomeHero.png";
import { useNavigate } from "react-router-dom";

export default function HomeMain1() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center 
                    px-6 sm:px-12 lg:px-20 xl:px-32 2xl:px-48 4k:px-64 
                    py-16 sm:py-20 lg:py-24 xl:py-28 2xl:py-32 bg-[#F2F2F2]">
      <div className="max-w-[1920px] 2xl:max-w-[2560px] 4k:max-w-[3840px] w-full 
                      grid grid-cols-1 lg:grid-cols-2 gap-12 sm:gap-16 lg:gap-20 2xl:gap-32 items-center">
        
        {/* Left Content Section */}
        <div className="space-y-10 sm:space-y-12 lg:space-y-16">
          <div className="space-y-6 relative">
            <h1
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-6xl 2xl:text-7xl 4k:text-8xl 
                         font-bold leading-tight text-[#0A476C]"
              style={{ fontFamily: '"Futura Bold", Sans-serif' }}
            >
              We Help
              <br />
              Law Firms
              <br />
              Get More Motor Vehicle Accident Case.
            </h1>
            <div className="absolute bottom-0 left-0 w-full h-2 bg-[#FC821F] translate-y-2"></div>
          </div>

          <p className="max-w-2xl text-base sm:text-lg md:text-xl lg:text-2xl 2xl:text-3xl leading-relaxed font-normal text-[#0A476C]" 
             style={{ fontFamily: '"Avenir Book", sans-serif' }}
          >
            At Belief Marketing Enterprises, we partner with attorneys and law firms to deliver{" "}
            <span className="font-bold">exclusive, qualified accident leads</span> 
            through SEO, paid ads, and custom funnels. You focus on winning cases while we keep your intake pipeline full.
          </p>

          {/* Button */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
            <button
              onClick={() => navigate("/About")}
              className="rounded-2xl px-6 py-3 text-base sm:text-lg lg:text-xl font-semibold 
                         bg-[#0A476C] text-white border-2 border-[#F4F0E3] 
                         transition-colors duration-200 hover:bg-[#FC821F] hover:text-[#0A476C]"
            >
              Get Legal Leads
            </button>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="relative px-4 sm:px-6 lg:px-0">
          <img
            src={imag1st}
            alt="Hero banner - Law firm marketing"
            className="w-full h-auto rounded-2xl object-cover shadow-lg"
          />
        </div>
      </div>
    </div>
  );
}
